import { useEffect } from "react";
import { warmPoseLandmarker } from "./poseModel";

/**
 * Starts the shared pose-model download AND builds the first landmarker the moment the app is on
 * screen — ANY screen, not just the upload one — so by the time someone reaches an upload the
 * 30 MB model, its runtime and a ready landmarker are already there, instead of them sitting on
 * "Loading the pose model…" / "Starting the pose model…" (the first tester, on Safari).
 * Renders nothing. A failure here is silent: the extraction step retries the load and reports it
 * if it fails again.
 */
export default function PoseModelWarmup() {
  useEffect(() => { warmPoseLandmarker("VIDEO").catch(() => undefined); }, []);
  return null;
}
